import {
  useEffect,
  useRef,
  useState,
  type SetStateAction,
  type Dispatch,
  type MutableRefObject,
} from 'react';

/**
 * Utility hook that provides a ref as state and also a mutable ref that is updated
 * when the ref changes.
 */
export function useStateRef<T>(): [
  element: T | null,
  setElement: Dispatch<SetStateAction<T | null>>,
  elementRef: MutableRefObject<T | null>,
] {
  const [element, setElement] = useState<T | null>(null);

  const elementRef = useRef<T | null>(null);

  useEffect(() => {
    if (element !== elementRef.current) {
      elementRef.current = element;
    }
  }, [element]);

  return [element, setElement, elementRef];
}
